import { Link } from "react-router-dom";
import { Heart, Scale, Search } from "lucide-react";
import { useApp } from "../context/AppContext";
import PropertyCard from "../components/PropertyCard";

export default function Saved() {
  const { saved, recentSearches } = useApp();
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
      <div className="flex items-center gap-2 mb-6"><Heart size={22} className="text-pbs-coral" /><h1 className="text-2xl sm:text-3xl font-extrabold text-pbs-dark">Your Shortlist</h1></div>

      {recentSearches.length > 0 && (
        <div className="mb-8">
          <h2 className="text-sm font-bold text-pbs-grey mb-3 flex items-center gap-1.5"><Search size={14} /> Recent Searches</h2>
          <div className="flex flex-wrap gap-2">
            {recentSearches.map((s, i) => <span key={i} className="text-sm bg-white border border-pbs-line px-3 py-1.5 rounded-full text-pbs-dark">{s}</span>)}
          </div>
        </div>
      )}

      {saved.length === 0 ? (
        <div className="py-20 text-center">
          <Heart size={48} className="mx-auto text-pbs-purple/30" />
          <p className="mt-4 text-lg font-bold text-pbs-dark">No saved properties yet</p>
          <p className="text-pbs-grey mt-1">Tap the heart on any listing to shortlist it here.</p>
          <Link to="/properties" className="mt-6 inline-block pbs-gradient text-white font-bold px-6 py-3 rounded-xl">Explore Properties</Link>
        </div>
      ) : (
        <>
          <div className="flex justify-end mb-4">
            <Link to="/compare" className="inline-flex items-center gap-1.5 text-pbs-purple font-bold text-sm"><Scale size={15} /> Compare saved</Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {saved.map((p) => <PropertyCard key={p.slug} property={p} compact />)}
          </div>
        </>
      )}
    </div>
  );
}
